import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import { ContinueAccountRecovery } from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class ContinueAccountRecoveryService {
  continueAccountRecoveryHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.continueAccountRecovery+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  continueAccountRecovery = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<ContinueAccountRecovery> => {
    const getContinueAccountRecovery = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const continueAccountRecoveryUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getContinueAccountRecovery
      }
    ];

    return new ApiBuilder<undefined, ContinueAccountRecovery>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(continueAccountRecoveryUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.continueAccountRecoveryHeader)
      .errorHandler(this._errorHandler)
      .library('CONTINUE_ACCOUNT_RECOVERY_SERVICE')
      .withCredentials(true)
      .create();
  };
}
